import { apiFetch } from "./client";

/**
 * D-055 S5 — Supervisor Control API (visual v0.2 екран 5).
 * GET /Custom/frontend/meetings/control — role-gated (manager → 403).
 * Review-дії — ІСНУЮЧИЙ S1 endpoint POST /Custom/interactions/:id/review.
 */

export type ControlView =
  | "pending_review"
  | "no_submission"
  | "overdue"
  | "no_next_action"
  | "returned";

export interface ControlReport {
  text: string;
  outcome: string | null;
  riskMarkers: string[];
  nextActionRequired: "yes" | "no" | "unknown" | null;
  nextActionReason: string | null;
}

export interface ControlItem {
  id: string;
  summary: string;
  meetingStatus: string;
  occurredAt: string | null;
  accountName: string | null;
  targetHoldingId: string | null;
  managerName: string | null;
  risk: boolean;
  reportSubmitted: boolean;
  reportSubmittedAt: string | null;
  reportSlaDueAt: string | null;
  reportOverdueSince: string | null;
  reviewStatus: "not_required" | "pending_review" | "accepted" | "returned";
  reviewComment: string | null;
  /** D-151 S2 (C8) — provenance-pill «заповнив керівник за менеджера». */
  reportSubmissionMode: "own" | "supervisor_on_behalf" | "admin_override" | null;
  reportSubmittedByName: string | null;
  reportSubmittedForName: string | null;
  reportOnBehalfReason: string | null;
  report: ControlReport | null;
  allowedActions: {
    canReview: boolean;
    canReturn: boolean;
  };
}

export interface ControlResponse {
  items: ControlItem[];
  total: number;
  /** + on_behalf_submitted — лічильник «заповнено керівником» (P19). */
  counts: Record<ControlView, number> & { on_behalf_submitted?: number };
  view: ControlView;
}

export function fetchMeetingsControl(
  params: { view?: ControlView },
  signal?: AbortSignal,
): Promise<ControlResponse> {
  return apiFetch<ControlResponse>("/Custom/frontend/meetings/control", {
    method: "GET",
    query: { view: params.view },
    signal,
  });
}

export interface ReviewResponse {
  status: string;
  interactionId: string;
  reviewStatus: string;
}

/** S1 review: accept · return (comment ОБОВʼЯЗКОВИЙ — server enforce). */
export function reviewMeetingReport(
  id: string,
  action: "accept" | "return",
  comment?: string,
): Promise<ReviewResponse> {
  return apiFetch<ReviewResponse>(
    `/Custom/interactions/${encodeURIComponent(id)}/review`,
    { method: "POST", body: { action, comment } },
  );
}
